import * as React from "react";
import InlineCard from "./InlineCard";
import preloadedCards from "./preloadedCards";
import { useTranslation } from "./i18n";
var TrumpE = function (props) {
    var _a;
    var trump = props.trump;
    var t = useTranslation().t;
    if ("Standard" in trump) {
        var _b = trump.Standard, suit_1 = _b.suit, rank_1 = _b.number;
        // `.find` + guard: an unrecognised suit/rank pair used to index `[0]` on an
        // empty array and throw during render, blanking the game UI. Fall back to
        // naming the rank alone, which is still useful to the player.
        var card = (_a = preloadedCards.find(function (v) { return v.typ === suit_1 && v.number === rank_1; })) === null || _a === void 0 ? void 0 : _a.value;
        if (card === undefined) {
            return (React.createElement("div", { className: "trump" },
                t("trump.suitIs"),
                " ",
                suit_1,
                " (",
                t("trump.rank"),
                " ",
                rank_1,
                ")"));
        }
        return (React.createElement("div", { className: "trump" },
            t("trump.suitIs"),
            " ",
            React.createElement(InlineCard, { card: card }),
            " (",
            t("trump.rank"),
            " ",
            rank_1,
            ")"));
    }
    else if (trump.NoTrump.number !== undefined &&
        trump.NoTrump.number !== null) {
        return (React.createElement("div", { className: "trump" }, t("trump.noTrumpRank", { rank: trump.NoTrump.number })));
    }
    else {
        return React.createElement("div", { className: "trump" }, t("trump.noTrump"));
    }
};
export default TrumpE;
